export default __webpack_public_path__ + "static/media/img-0676-bosnia-full-face.4f682022.png";